export enum ShipmentTransportationPaymentStatus {
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}
